import { NgModule } from '@angular/core';
import { UserSelectorModalComponent } from './user-selector-modal.component';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '@app/modules/directives.module';
import { FilterUsersPipe } from './filter-users.pipe';
import { FullHeightContainerModule } from '@app/modules/full-height-container/full-height-container.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule,
    FilterUsersPipe,
    FullHeightContainerModule
  ],
  exports: [UserSelectorModalComponent],
  declarations: [UserSelectorModalComponent]
})
export class UserSelectorModalModule {}
